var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesmrktLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 32,
    viewBox: "0 0 194 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4275 26.9408C14.0269 26.9408 15.3284 26.2063 15.3284 24.6407C15.3284 23.3993 13.1917 22.3853 8.96385 21.6474C3.53195 20.6646 0.744667 18.2713 0.695951 14.4503C0.695951 9.20171 4.87166 6.71533 10.4985 6.62567C13.6557 6.62567 16.1635 7.31537 18.0216 8.69478C19.8358 10.1225 20.8112 12.1019 20.9482 14.6331H17.0508C15.6102 14.5883 14.6811 14.0813 14.3088 13.1158C13.8912 12.0571 12.6385 11.4571 10.5924 11.4571C8.17395 11.4571 6.95951 12.1122 6.95951 13.3468C6.95951 14.5814 8.53932 15.5538 11.7441 16.1539C15.9199 16.9815 18.6654 18.0403 20.012 19.2851C20.5725 19.8578 21.0129 20.5348 21.308 21.277C21.603 22.0193 21.7468 22.812 21.7311 23.6096C21.7311 29.5962 16.9916 31.8033 10.4914 31.8033C7.06042 31.8033 4.46104 31.079 2.7838 29.641C0.925615 28.2616 0 26.1407 0 23.3337H6.31575C6.45494 26.0029 8.40361 26.9236 11.4275 26.9236",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4929 13.3353H24.329C25.0687 8.83241 28.2669 6.62573 33.9238 6.62573C40.6917 6.62573 44.1192 8.83241 44.2581 13.3353V21.5974C44.2581 28.3069 40.1813 31.295 33.5522 31.7528C27.6488 32.2142 23.5859 29.5014 23.5859 24.1242C23.7214 18.2994 27.9891 16.7331 34.2015 16.1375C36.8442 15.8139 38.188 15.0359 38.188 13.7002C38.0491 12.3231 36.7504 11.6346 34.2015 11.6346C32.0207 11.6346 30.8158 12.1854 30.4929 13.3353ZM38.2783 21.3288V19.0774C36.6938 19.7248 35.0492 20.217 33.3681 20.5474C30.9095 21.0087 29.6594 22.1585 29.6594 23.9486C29.7983 25.8798 30.8158 26.799 32.7639 26.799C36.1948 26.799 38.2783 24.7748 38.2783 21.3288Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5956 2.99055V31.2732H48.5V0H51.6611C52.4423 0.0152841 53.1866 0.336661 53.7349 0.895464C54.2833 1.45427 54.5921 2.20618 54.5956 2.99055Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6328 31.8033C61.2095 31.5732 57.5117 27.3093 57.5117 19.053C57.5117 10.7968 61.272 6.68415 68.7406 6.62573C76.5323 6.62573 80.2092 11.35 79.7331 20.8431H63.8542C64.087 24.5572 65.71 26.4366 68.7197 26.4366C70.155 26.4366 71.4999 25.8422 72.7094 24.6947C72.9721 24.4083 73.2947 24.1818 73.6547 24.0311C74.0148 23.8804 74.4038 23.809 74.7947 23.8219H79.3404C77.9954 28.9757 74.6556 31.8033 68.6259 31.8033M63.948 16.4865H73.1786C72.8067 13.274 71.2776 11.6248 68.6328 11.6248C65.988 11.6248 64.4103 13.274 63.948 16.4865Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3148 26.9236C95.9168 26.9236 97.2143 26.1891 97.2143 24.6235C97.2143 23.3821 95.0785 22.3681 90.8554 21.6302C85.4218 20.6646 82.6355 18.2714 82.5902 14.4504C82.5902 9.20177 86.7646 6.7154 92.386 6.62573C95.5445 6.62573 98.0527 7.31544 99.9102 8.69484C101.72 10.1225 102.694 12.102 102.835 14.6332H98.9328C97.4961 14.5883 96.5672 14.0814 96.1951 13.1158C95.7777 12.0571 94.5218 11.4571 92.48 11.4571C90.0657 11.4571 88.8587 12.102 88.8587 13.3469C88.8587 14.5918 90.438 15.5539 93.6417 16.154C97.8161 16.9816 100.561 18.0403 101.907 19.2852C102.466 19.8583 102.907 20.5353 103.202 21.2774C103.497 22.0196 103.64 22.8121 103.626 23.6097C103.626 29.5962 98.8875 31.8033 92.386 31.8033C88.9491 31.8033 86.3506 31.0688 84.6774 29.6411C82.8198 28.2617 81.8945 26.1408 81.8945 23.3338H88.2256C88.3647 26.0029 90.3127 26.9236 93.3322 26.9236",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.281 16.9589V31.1841H112.518V15.7255C112.564 13.2108 113.95 11.9774 116.677 11.9774C119.404 11.9774 120.794 13.2108 120.933 15.7255V31.1841H127.132V15.818C127.177 13.3032 128.567 12.0493 131.29 12.0493C134.014 12.0493 135.408 13.2861 135.546 15.818V28.2583C135.546 30.1768 136.565 31.1362 138.599 31.2733H141.791V17.0514C141.835 10.1478 138.367 6.71481 131.395 6.71481C128.248 6.71481 125.85 7.3555 124.086 8.68141C122.325 7.31096 119.928 6.62573 116.777 6.62573C109.792 6.62573 106.277 10.0518 106.277 16.9589",
    fill: "url(#paint0_linear_18652_56998)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.859 6.89075C149.47 6.89075 145.157 10.8066 144.969 18.6901V31.2733H151.359V18.5969C151.359 15.0471 153.112 13.2514 156.62 13.2514H158.75V6.89075H157.859Z",
    fill: "url(#paint1_linear_18652_56998)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.931 0V26.704C183.884 29.4316 185.017 30.8576 187.38 31.093C189.58 31.3158 191.797 31.3321 194 31.1414V26.4756H192.055C190.827 26.4756 190.21 25.9183 190.21 24.9042V11.3669H190.872C191.285 11.3759 191.697 11.303 192.081 11.1523C192.465 11.0016 192.813 10.7765 193.105 10.4906C193.398 10.2046 193.628 9.86366 193.781 9.48838C193.935 9.1131 194.009 8.71126 194 8.30715V6.97801H190.218V3.09441C190.218 1.47798 188.846 0 187.192 0H183.931Z",
    fill: "url(#paint2_linear_18652_56998)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M161.668 0V31.2732H167.813V22.398C167.79 22.113 167.877 21.8297 168.058 21.6072C168.238 21.3845 168.497 21.2396 168.783 21.2026C169.569 21.2026 170.355 21.8916 171.139 23.2697L175.478 31.2732H182.87L174.326 16.8476L182.776 7.81745H175.388L172.651 10.9424L169.392 14.6633L167.813 16.4652V2.99055C167.81 2.20618 167.498 1.45427 166.946 0.895464C166.394 0.336661 165.643 0.0152841 164.855 0H161.668Z",
    fill: "url(#paint3_linear_18652_56998)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18652_56998",
    x1: 124.044,
    y1: 31.376,
    x2: 124.044,
    y2: -0.726717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4EBA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#70C242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8CC93E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A1CE3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B0D238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B9D436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD536"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18652_56998",
    x1: 151.863,
    y1: 31.4666,
    x2: 151.863,
    y2: -0.889153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4EBA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#70C242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8CC93E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A1CE3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B0D238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B9D436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD536"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18652_56998",
    x1: 188.963,
    y1: 31.6122,
    x2: 188.963,
    y2: -0.82033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4EBA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#70C242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8CC93E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A1CE3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B0D238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B9D436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD536"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18652_56998",
    x1: 172.271,
    y1: 31.4317,
    x2: 172.271,
    y2: -0.850996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#4EBA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#70C242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8CC93E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A1CE3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B0D238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B9D436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD536"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesmrktLogo);
export default __webpack_public_path__ + "static/media/SalesmrktLogo.c0d9340736870415a5ab874c1c777023.svg";
export { ForwardRef as ReactComponent };